<template>
  <v-layout justify-center mt-3>
    <v-flex xs12 sm8 md6 xl4>
      <v-card>
        <v-card-title
          class="text-uppercase justify-center"
          :class="registro ? 'yellow' : 'green'"
        >
          <span v-if="!registro">Ingreso</span>
          <span v-if="registro">Registro</span>
        </v-card-title>
        <v-text-field
          v-model="email"
          id="email"
          required
          label="Correo electrónico"
        ></v-text-field>
        <v-text-field
          v-model="password"
          id="password"
          required
          :type="showPasswordA ? 'text' : 'password'"
          :append-icon="showPasswordA ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPasswordA = !showPasswordA"
          label="Contraseña"
        ></v-text-field>
        <v-btn class="ml-2 mt-2" text @click="reset"
          >¿Ha olvidado la contraseña?</v-btn
        >
        <v-text-field
          v-if="registro"
          v-model="nombre"
          id="name"
          required
          label="Nombre"
        ></v-text-field>
        <v-card color="error">
          <v-card-text class="white--text" v-if="error">
            <strong>{{ errorMessage }}</strong>
          </v-card-text>
        </v-card>
        <v-card-text>
          <v-btn
            id="loginButton"
            class="mb-4"
            block
            :color="registro ? 'yellow' : 'green'"
            @click="login"
          >
            <v-icon left dark>mdi-mail</v-icon
            >{{ registro ? "Registro" : "Login" }}
          </v-btn>

          <v-btn class="mb-4" block color="error" @click="google">
            <v-icon left dark>mdi-google</v-icon>Google
          </v-btn>
          <v-btn class="mb-4" block color="info" @click="facebook">
            <v-icon left dark>mdi-facebook</v-icon>Facebook
          </v-btn>
        </v-card-text>
        <v-card-text>
          <v-btn block v-if="!registro" @click="registro = true"
            >¿No tienes cuenta? Registrate aquí</v-btn
          >
          <v-btn block v-if="registro" @click="registro = false"
            >Ya tienes cuenta?</v-btn
          >
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

import { firebase, db, auth } from "@/firebase";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      registro: false,
      showPasswordA: false,
      showPasswordB: false,
      error: false,
      errorMessage: "",
    };
  },
  computed: {
    ...mapState(["usuario"]),
  },
  created() {
    /* auth().onAuthStateChanged((user) => {
      if (user) {
        // User signed in, you can get redirect result here if needed.
        // ...
        this.$router.push("/home");
        // ....
      } else {
        // Show sign in screen with button above.
      }
    }); */
  },
  methods: {
    ...mapActions(["setUsuario"]),
    ...mapMutations(["nuevoUsuario"]),

    reset: function () {
      if (this.email.length > 0){
        auth
        .sendPasswordResetEmail(this.email)
        .then(function () {
          // Email sent.
        })
        .catch(function (error) {
          // An error happened.
        });
      }else {
        alert("Debe introducir un correo electrónico")
      }
      
    },

    login: function () {
      if (this.registro) {
        this.error = false;
        auth.createUserWithEmailAndPassword(this.email, this.password).then(
          (firebaseUser) => {
            this.$router.replace("home");
          },
          (err) => {
            //alert("Oops. " + err.message);
            this.error = true;
            this.errorMessage = err.message;
          }
        );

        auth.onAuthStateChanged((firebaseUser) => {
          if (firebaseUser) {
            firebaseUser.sendEmailVerification().then(
              function () {
                console.log("send Verification");
              },
              function (error) {
                console.log("not send Verification");
              }
            );
          } else {
            console.log("not logged in");
          }
        });
      }
      if (!this.registro) {
        this.error = false;
        auth.signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            // console.log("user login in login");
            // console.log(user.user);
            // this.setUsuario(user.user);
            console.log(user);
            this.$router.replace("home");
          },
          (err) => {
            this.error = true;
            this.errorMessage = err.message;
            //alert("Oops. " + err.message);
          }
        );
      }
    },
    google() {
      console.log("google");
      const provider = new firebase.auth.GoogleAuthProvider();
      this.ingresar(provider);
    },
    facebook() {
      console.log("Facebook");
      const provider = new firebase.auth.FacebookAuthProvider();
      this.ingresar(provider);
    },
    async ingresar(provider) {
      //   const provider = new firebase.auth.GoogleAuthProvider();
      this.error = false;
      firebase.auth().languageCode = "es";
      var user;
      var result;
      try {
        // const result = await auth.signInWithPopUp(provider);

        result = await firebase.auth().signInWithRedirect(provider);
        this.$router.replace("home");

        /*  .then(function() {
            return firebase.auth().getRedirectResult();
          })
          .then(function(result) {
            // This gives you a Google Access Token.
            // You can use it to access the Google API.
            var token = result.credential.accessToken;
            // The signed-in user info.

            user = result.user;

            // ...
          })
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
          }); */

        //const user = result.user;
        //console.log(user);
        /* console.log("result after login with google");
        console.log(result);
        this.setUsuario(user);
        console.log("result after login with google");

      this.$router.replace("home"); */
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMessage = err.message;
      }
    },
  },
};
</script>
